import { Subject } from 'rxjs';
import { DrawerAction, DrawerResult } from '../models/drawer.types';

/**
 * Reference to an opened drawer.
 * Injected into the component loaded in the drawer.
 */
export class DrawerRef<T = unknown, R = unknown> {
  private readonly _afterClosed = new Subject<DrawerResult<R>>();

  /**
   * Observable that emits when the drawer is closed
   */
  readonly afterClosed$ = this._afterClosed.asObservable();

  constructor(public readonly data?: T) {}

  /**
   * Closes the drawer with a result
   */
  close(data?: R, action: DrawerAction = DrawerAction.CONFIRMED): void {
    this._afterClosed.next({ action, data });
    this._afterClosed.complete();
  }

  /**
   * Closes the drawer with a confirmed action
   */
  confirm(data?: R): void {
    this.close(data, DrawerAction.CONFIRMED);
  }

  /**
   * Closes the drawer with a cancelled action
   */
  cancel(): void {
    this.close(undefined, DrawerAction.CANCELLED);
  }
}
